import { render } from "./Footer.vue?vue&type=template&id=27c95ccc&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=27c95ccc&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\blendify\\blendify-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c95ccc"]])

export default __exports__